import { useRouteError } from "react-router-dom";

import ErrorPage from "@/components/ui/ErrorPage";

export default function RouteErrorPage() {
  const error = useRouteError();

  return <ErrorPage error={error} />;
}
